export default __webpack_public_path__ + "static/media/tool-icon-shirt-orange-12.d53a8790.svg";